import React from "react";
import CustomTabs from "components/Shared/CustomTabs";
import { useGetNotesBySourceQuery } from "store/services/noteApi";
import { useSearchParams } from "react-router-dom";
import CustomTabPanel from "components/Shared/CustomTabPanel";
import NoteTab from "../../Note/Notetab";
import RowsSkeleton from "components/Shared/Skeleton/RowsSkeleton";
import { useGetDocumentsBySourceQuery } from "store/services/documentApi";
import DocumentsTab from "../../Document/DocumentTab";
import { useSmsIntegrationDetailContext } from "contexts/SmsIntegrationDetailContext";

const SmsIntegrationDetailTab = () => {
  const [searchParams] = useSearchParams();

  const activeTab = searchParams.get("tab") || "notes";

  const { smsIntegrationDetail } = useSmsIntegrationDetailContext();

  const { data: notes } = useGetNotesBySourceQuery(
    {
      source: "SmsIntegration",
      sourceRef: smsIntegrationDetail?._id,
    },
    { skip: !smsIntegrationDetail?._id }
  );

  const { data: documents } = useGetDocumentsBySourceQuery(
    { source: "SmsIntegration", sourceRef: smsIntegrationDetail?._id },
    { skip: !smsIntegrationDetail?._id }
  );

  const tabs = [
    {
      label: "Notes",
      value: "notes",
      badgeCount: notes?.length || 0,
    },
    { label: "Document", value: "document", badgeCount: documents?.totalItems },
  ];

  return (
    <>
      <CustomTabs tabs={tabs} activeTab={activeTab} />

      {smsIntegrationDetail ? (
        <>
          <CustomTabPanel activeTab={activeTab} value="notes">
            <NoteTab
              source="SmsIntegration"
              sourceRef={smsIntegrationDetail._id}
            />
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="document">
            <DocumentsTab
              source="SmsIntegration"
              sourceRef={smsIntegrationDetail._id}
            />
          </CustomTabPanel>
        </>
      ) : (
        <RowsSkeleton />
      )}
    </>
  );
};

export default SmsIntegrationDetailTab;